import React from 'react';
import { motion } from 'framer-motion';
import Button from '../components/ui/Button';

const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 1, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function Thrive() {
  const CHECKOUT_URL = "https://buy.stripe.com/28E3cvgsb3XQeug1ezcfK05";
  const BOOKING_URL = "https://link.nordiccrm.ca/widget/bookings/dorman-ernest-baltazar-personal-calendar-qg2bbc8wa";

  return (
    <div className="w-full bg-kin-black">
      <section className="relative min-h-[90vh] flex items-center justify-center px-6 pt-32 pb-20 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] h-[90vh] bg-kin-gold/5 blur-[180px] rounded-full pointer-events-none"></div>
        <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center">
          <FadeUp> <p className="text-kin-gold tracking-[0.4em] text-xs uppercase font-light mb-10"> Wholistic Wellness For Entrepreneurs </p> </FadeUp>
          <FadeUp delay={0.2}> <h1 className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-serif text-balance leading-[1.1] text-kin-ivory mb-12"> Stop Running Your Business On <span className="italic">Fumes, Anxiety,</span> And Empty Reps. </h1> </FadeUp>
          <FadeUp delay={0.6} className="flex flex-col items-center gap-6">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="px-16 py-6 text-sm"> Get THRIVE </Button>
            </a>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-xs uppercase tracking-[0.3em] text-kin-ivory/40 hover:text-kin-gold transition-colors">
              Talk With Dorman First
            </a>
          </FadeUp>
        </div>
      </section>

      <section className="py-40 md:py-60 px-6 text-center relative overflow-hidden bg-[#09090b]">
        <div className="max-w-4xl mx-auto relative z-10">
          <FadeUp> <h2 className="text-3xl md:text-5xl lg:text-7xl font-serif text-kin-ivory leading-tight mb-16"> Protect Your Energy <br/> <span className="italic text-kin-gold font-normal">Before Burnout Forces You To.</span> </h2> </FadeUp>
          <FadeUp delay={0.2}>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="px-16 py-6 text-sm"> Start Thriving </Button>
            </a>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}